// Booking submission destination. The ONLY place the Forms address lives.
// 'forms'    -> native Forms ("Repair Booking Request") configured for THIS project.
// 'disabled' -> no destination; the form shows an "online booking not set up" notice and sends nothing.
// There is intentionally no legacy Backend option and no fallback.
export type BookingMode = 'forms' | 'disabled';

export const BOOKING_MODE: BookingMode = 'forms';

// COPY-ISOLATION (UNVERIFIED): a copied site must point this at ITS OWN form, or set it to ''
// to show the unavailable state. Do not assume duplication rewrites this address.
export const BOOKING_FORM_URL = 'https://readdy.ai/api/form/dbbd70n4q28rvt1ib9ng';

export const bookingAvailable = BOOKING_MODE === 'forms'
  && /^https:\/\/readdy\.ai\/api\/form\/[a-z0-9]+$/.test(BOOKING_FORM_URL);